import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["defaultValue", "use"];
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { withoutClassName } from './helpers';
import { jsx as _jsx } from "react/jsx-runtime";
export let _capturedPropsForTesting = {};
export default function TextInputAdapter(_ref) {
  let {
      defaultValue,
      use
    } = _ref,
    commonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const rest = withoutClassName(commonProps);
  _capturedPropsForTesting = Object.assign({
    defaultValue,
    use
  }, rest);
  return /*#__PURE__*/_jsx(TextInput, Object.assign({
    "data-test-id": "TextInput",
    defaultValue: defaultValue,
    use: use
  }, rest));
}